<template>
  <div>
    <h3>
      <strong
        >Explanation of the Current Alert Level of
        <span v-if="alert && alert.fields && alert.fields.threatLevel">
          {{ alert.fields.threatLevel.value }}
        </span>
      </strong>
    </h3>
    <p>
      <strong>The alert level is the overall current threat level.</strong>
    </p>
    <p>
      <span v-if="alert && alert.fields && alert.fields.alertLevelDescription">
        {{ alert.fields.alertLevelDescription.value }}
      </span>
    </p>
    <p>
      <a href="/cybersecurity-threats/alert-level" class="c-cta--secondary"
        >Read more about our approach</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: 'CIS-Latest-Alert',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  computed: {
    alert() {
      return this.fields.alert;
    }
  }
};
</script>
